import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AdminTopNav } from "./AdminTopNav";
import { AdminBottomNav } from "./AdminBottomNav";

/**
 * Responsive shell for /admin/* routes.
 *
 * Cream-light theme (admin portal is editorial — different mood from the
 * utilitarian staff portal). TopNav on md+, BottomNav on <md.
 */
export const AdminLayout = () => {
  const location = useLocation();
  const mainRef = useRef(null);

  useEffect(() => {
    if (mainRef.current) mainRef.current.scrollTop = 0;
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen bg-napoli-cream flex flex-col text-napoli-espresso">
      <AdminTopNav />
      <main
        ref={mainRef}
        data-testid="admin-page"
        className="relative flex-1 pb-[88px] md:pb-12"
      >
        <div
          key={location.pathname}
          className="animate-in fade-in duration-200"
          data-testid="admin-page-content"
        >
          <Outlet />
        </div>
      </main>
      <AdminBottomNav />
    </div>
  );
};

export default AdminLayout;
